import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'sku-modifier-group-picker.label',
    defaultMessage: 'Select modifiers',
  },
  searchPlaceholder: {
    id: 'sku-modifier-group-picker.search-placeholder',
    defaultMessage: 'Select modifiers',
  },
  addModifierGroup: {
    id: 'sku-modifier-group-picker.add-modifier-group',
    defaultMessage: 'Add modifier',
  },
  noGroups: {
    id: 'sku-modifier-group-picker.no-groups',
    defaultMessage: 'No modifiers available. Add a modifier to get started.',
  },
  noResults: {
    id: 'sku-modifier-group-picker.no-results',
    defaultMessage: 'No modifiers found.',
  },
  removeGroup: {
    id: 'sku-modifier-group-picker.remove-group',
    defaultMessage: 'Remove',
  },
  removeGroupAriaLabel: {
    id: 'sku-modifier-group-picker.remove-group-aria-label',
    defaultMessage: 'Remove {groupName}',
  },
});
